import { useQuery } from '@tanstack/react-query';
import type { ScopeCentre } from '@munifocus/contracts-gov';
import { api } from './api-client';
import { useOptionalScope } from '../providers/ScopeProvider';

/**
 * Where the active municipality is, for a map with nothing pinned to fit to.
 *
 * The registry carries no coordinates, so the API geocodes the place once and
 * remembers it; here it is cached for the session, because a town does not move
 * while someone is looking at it. A company scope, or a place the geocoder
 * could not find, answers null and the caller falls back to the province.
 */
export function useActiveScopeCentre() {
  // Optional: the maps also render in component tests with no scope above.
  const active = useOptionalScope()?.active;
  const isPlace = active?.kind === 'local_government';
  return useQuery({
    queryKey: ['gov-map', 'centre', active?.kind ?? '', active?.id ?? ''],
    enabled: isPlace,
    queryFn: async () => {
      const { data } = await api.get<ScopeCentre>('/administration/session/centre', {
        params: { scopeKind: active?.kind, scopeId: active?.id },
      });
      return data.centre;
    },
    staleTime: Infinity,
    retry: false,
  });
}
